import * as React from "react";
import * as ReactGA from "react-ga";
import * as CopyToClipboard from "react-copy-to-clipboard";
import { FaAngleDoubleRight, FaAngleDoubleLeft, FaCheck, FaCheckCircle } from "react-icons/fa";
import { Translate, withLocalize, Language, LocalizeContextProps } from "react-localize-redux";
import { Link, Redirect, RouteComponentProps } from "react-router-dom";
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress } from "reactstrap";
import IOffer from "../models/Offer";
import ApiService from "../services/ApiService";
import "./Finished.scss";
import Jumbotron from "./Jumbotron";
import Navbar from "./Navbar";
import StepperMobile from "./StepperMobile";

type IProps = {
  emailSentStatus: boolean | undefined;
  emailSentAddress?: string;
  language: Language;
  languageChanged: any;
  newOffer: any;
  offers: IOffer[];
} & LocalizeContextProps &
  RouteComponentProps;

interface IState {
  copiedText: string;
  emailSentAddress: string;
  currentAlertTime: number;
  showCopiedDialog: boolean;
  showEmailFailed: boolean;
  showEmailSuccess: boolean;
}

class Finished extends React.Component<IProps, IState> {
  private alertHideStopped: boolean = false;
  private api: ApiService = new ApiService();
  private hideAlertTimeout: number;
  private interval: NodeJS.Timeout;
  private OFFERHOST = process.env.OFFERURL || "";
  private offerUrl = "";

  public constructor(props: IProps) {
    super(props);

    this.hideAlertTimeout = 10000; // ms

    this.state = {
      copiedText: "",
      currentAlertTime: +this.hideAlertTimeout,
      emailSentAddress: "",
      showCopiedDialog: false,
      showEmailFailed: false,
      showEmailSuccess: false,
    };

    this.handleCopyCode = this.handleCopyCode.bind(this);
    this.handleCopyUrl = this.handleCopyUrl.bind(this);
    this.handleCopied = this.handleCopied.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleNewOffer = this.handleNewOffer.bind(this);
    this.handleResendEmail = this.handleResendEmail.bind(this);
    this.toggleAlertHide = this.toggleAlertHide.bind(this);
  }

  public render() {
    if (!this.props.offers || !this.props.offers.length || !this.props.offers[0].publicIdentifier) {
      return <Redirect to="/" />;
    }
    this.offerUrl = this.OFFERHOST + (this.props.offers[0] ? this.props.offers[0].publicIdentifier + (this.props.activeLanguage ? "?language=" + this.props.activeLanguage.code : "") : "");

    return (
      <div className="finished">
        <Alert color="info" isOpen={this.state.showCopiedDialog} toggle={this.handleDialogClose} onMouseOver={this.toggleAlertHide} onMouseOut={this.toggleAlertHide}>
          <div className="d-flex align-items-center">
            <span className="check mr-3">
              <FaCheck />
            </span>
            <span>
              <Translate id="TextCopied" data={{ link: this.state.copiedText }} />
            </span>
          </div>
          <Progress className="mt-3" animated={true} color="info" value={(this.state.currentAlertTime / this.hideAlertTimeout) * 100} />
        </Alert>
        <Alert color="success" isOpen={this.state.showEmailSuccess} toggle={this.handleDialogClose}>
          <div className="d-flex align-items-center">
            <span className="check mr-3">
              <FaCheck />
            </span>
            <span>
              <Translate id="EmailSuccess" data={{ email: this.state.emailSentAddress }} />
            </span>
          </div>
        </Alert>
        <Modal isOpen={this.state.showEmailFailed} toggle={this.handleDialogClose} centered={true}>
          <ModalHeader toggle={this.handleDialogClose}>
            <Translate id="EmailFailedTitle" />
          </ModalHeader>
          <ModalBody>
            <Translate id="EmailFailed" />
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" aria-label="Close" onClick={this.handleDialogClose}>
              <Translate id="No" />
            </Button>
            <Button color="success" onClick={this.handleResendEmail}>
              <Translate id="Yes" />
            </Button>
          </ModalFooter>
        </Modal>
        <Navbar current={3} summaryEnabled={true} isContactRequest={this.props.offers[0].isContactRequest} finishedEnabled={true} language={this.props.language} languageChanged={this.props.languageChanged} />
        <Jumbotron />
        <div className="container main-container">
          <StepperMobile current={3} isContactRequest={this.props.offers[0].isContactRequest} summaryEnabled={true} finishedEnabled={true} />
          <div className="my-5">
            <h3 className="mb-4">
              <span className="mr-3">
                {!this.props.offers[0].isContactRequest && <Translate id="OfferCreated" />}
                {this.props.offers[0].isContactRequest && <Translate id="ContactRequestTitle" />}
              </span>
              <span className="created-check">
                <FaCheckCircle />
              </span>
            </h3>
            <div>
              {!this.props.offers[0].isContactRequest && process.env.REACT_APP_FE_MODE !== "embed" && <Translate id="OfferCreatedDisclaimer" />}
              {!this.props.offers[0].isContactRequest && process.env.REACT_APP_FE_MODE === "embed" && (
                <div className="mt-4">
                  <Translate id="ContactSend" /> {this.props.offers[0].offerContact.emailAddress}
                </div>
              )}
              {(this.props.offers[0].isContactRequest || process.env.REACT_APP_FE_MODE === "embed") && (
                <div className="font-weight-bold mt-4">
                  <Translate id="ContactProfessional" />
                </div>
              )}
            </div>
          </div>
          {process.env.REACT_APP_FE_MODE !== "embed" && !this.props.offers[0].isContactRequest && (
            <div className="my-5 row justify-content-between">
              <div className="big-number col-auto mr-2">1</div>
              <div className="col">
                {this.props.offers.map((offer: IOffer, idx: number) => {
                  return (
                    <div key={idx} className="row mb-3">
                      <div className="col-12 col-sm">
                        <div className="font-weight-bold">
                          {offer.offerContact.companyName ? (
                            offer.offerContact.companyName
                          ) : (
                            <span>
                              <Translate id="Company" /> {idx + 1}
                            </span>
                          )}{" "}
                          <Translate id="OfferCode" />: {offer.token}
                        </div>
                        <div className="small d-none d-sm-block">
                          <Translate id="OfferCodeDisclaimer" />
                        </div>
                      </div>
                      <div className="col-12 col-sm-auto mt-2 mt-md-0">
                        <CopyToClipboard text={offer.token || ""} onCopy={this.handleCopyCode}>
                          <button className="btn btn-outline-primary">
                            <Translate id="CopyCode" />
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className="my-5 row justify-content-between">
            {process.env.REACT_APP_FE_MODE !== "embed" && !this.props.offers[0].isContactRequest && <div className="big-number col-auto mr-2">2</div>}
            <div className="col row">
              <div className="col-12 col-sm">
                {process.env.REACT_APP_FE_MODE !== "embed" && !this.props.offers[0].isContactRequest && (
                  <div className="font-weight-bold">
                    {this.props.offers.length === 1 ? (
                      <span>
                        {this.props.offers[0].offerContact.companyName} <Translate id="OfferURL" />
                      </span>
                    ) : (
                      <span>
                        <Translate id="ChainOfferURL" />
                      </span>
                    )}
                    :
                    <br />
                    <a href={this.offerUrl} target="_blank">
                      {this.offerUrl}
                    </a>
                  </div>
                )}
                {process.env.REACT_APP_FE_MODE !== "embed" && !this.props.offers[0].isContactRequest && (
                  <div className="small d-none d-sm-block">
                    <Translate id="OfferURLDisclaimer" />
                  </div>
                )}
              </div>
              {process.env.REACT_APP_FE_MODE !== "embed" && !this.props.offers[0].isContactRequest && (
                <div className="col-12 col-sm-auto mt-2 mt-md-0">
                  <CopyToClipboard text={this.offerUrl} onCopy={this.handleCopyUrl}>
                    <button className="btn btn-outline-primary">
                      <Translate id="CopyUrl" />
                    </button>
                  </CopyToClipboard>
                </div>
              )}
            </div>
          </div>
          <div className="my-5">
            <hr />
            <div className="my-4 row justify-content-between align-items-center">
              <div className="my-4 row justify-content-between align-items-center width-full col">
                {!this.props.offers[0].isContactRequest && (
                  <Link className="col-auto create-new-link" to="/" onClick={this.handleNewOffer}>
                    <Translate id="CreateNewOffer" />
                    <FaAngleDoubleRight />
                  </Link>
                )}
                {this.props.offers[0].isContactRequest && (
                  <Link to="/ContactRequest" className="netvisor-link ml-3 small font-weight-bold">
                    <FaAngleDoubleLeft /> <Translate id="BackToPreviousPage" />
                  </Link>
                )}
              </div>
              {!this.props.offers[0].isContactRequest && (
                <div className="col-12 col-md my-2 text-right">
                  <a href={this.offerUrl} onClick={this.handleGoToOfferAnalytics} target="_blank">
                    <Button color="primary">
                      <Translate id="GoToOfferURL" />
                    </Button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    if (process.env.REACT_APP_PRODUCTION === "true") {
      // Analytics page view
      ReactGA.pageview("/finished");
    }

    if (process.env.REACT_APP_FE_MODE !== "embed") {
      this.setState({
        emailSentAddress: this.props.emailSentAddress || "",
        showEmailFailed: this.props.emailSentStatus !== undefined && !this.props.emailSentStatus,
        showEmailSuccess: this.props.emailSentStatus !== undefined && this.props.emailSentStatus,
      });
    }
  }

  public componentWillUnmount() {
    clearInterval(this.interval);
  }

  private handleResendEmail() {
    if (this.props.offers && this.props.offers[0]) {
      this.api.sendEmail(this.props.offers[0].token || "", this.props.activeLanguage ? this.props.activeLanguage.code : "", process.env.REACT_APP_FE_MODE === "embed").subscribe(
        (res: any) => {
          this.setState({
            emailSentAddress: this.props.offers[0].offerCreator.emailAddress || "",
            showEmailSuccess: true,
          });
        },
        (error: any) => {
          console.error(error);
          this.setState({ showEmailFailed: true });
        }
      );
    }
  }

  private handleNewOffer() {
    this.props.newOffer();
  }

  private handleGoToOfferAnalytics() {
    if (process.env.REACT_APP_PRODUCTION === "true") {
      if (process.env.REACT_APP_FE_MODE === "internal") {
        // myynti.netvisor.fi
        ReactGA.event({
          action: "offer-visit",
          category: "myynti",
        });
      } else if (process.env.REACT_APP_FE_MODE === "embed") {
        // hinta.netvisor.fi
        ReactGA.event({
          action: "offer-visit",
          category: "verkko",
        });
      } else {
        // laskuri.netvisor.fi
        ReactGA.event({
          action: "offer-visit",
          category: "ao",
        });
      }
    }
  }

  private handleCopiedAnalytics() {
    if (process.env.REACT_APP_PRODUCTION === "true") {
      if (process.env.REACT_APP_FE_MODE === "internal") {
        // myynti.netvisor.fi
        ReactGA.event({
          action: "offer-copy",
          category: "myynti",
        });
      } else if (process.env.REACT_APP_FE_MODE === "embed") {
        // hinta.netvisor.fi
        ReactGA.event({
          action: "offer-copy",
          category: "verkko",
        });
      } else {
        // laskuri.netvisor.fi
        ReactGA.event({
          action: "offer-copy",
          category: "ao",
        });
      }
    }
  }

  private handleCopyUrl(copiedText: string, success: boolean) {
    if (success) {
      this.handleCopied(copiedText);
    } else {
      console.error("copy didnt work :(");
      alert("Copy this manually" + copiedText);
    }

    this.handleCopiedAnalytics();
  }

  private handleCopyCode(copiedText: string, success: boolean) {
    if (success) {
      this.handleCopied(copiedText);
    } else {
      console.error("copy didnt work :(");
      alert("Copy this manually" + copiedText);
    }
  }

  private handleCopied(copiedText: string) {
    this.alertHideStopped = false;

    this.setState({
      copiedText,
      currentAlertTime: this.hideAlertTimeout,
      showCopiedDialog: true,
    });

    clearInterval(this.interval);

    // Update alert progress
    this.interval = setInterval(() => {
      if (this.state.currentAlertTime > 0) {
        if (!this.alertHideStopped) {
          this.setState({ currentAlertTime: this.state.currentAlertTime - 100 });
        }
      } else {
        // Hide alert after timeout
        this.setState({ showCopiedDialog: false });
        clearInterval(this.interval);
      }
    }, 100);
  }

  private toggleAlertHide() {
    this.alertHideStopped = !this.alertHideStopped;
  }

  private handleDialogClose() {
    this.setState({
      showCopiedDialog: false,
      showEmailFailed: false,
      showEmailSuccess: false,
    });
  }
}

export default withLocalize<IProps>(Finished);
